import * as React from 'react';
import { Field } from 'formik';
import styled from 'styled-components';

export default class SelectField extends React.Component<any> {

  render() {
    return (
      <SelectFieldContainer>
        <Field as="select" {...this.props}>
          {this.props.children}
        </Field>
        <p><i className="arrow down" /></p>
      </SelectFieldContainer>
    );
  }
}
export const SelectFieldContainer = styled.div`
  margin: 0;
  p {
    float: right;
    margin: -2.5em 0.9375em 0 0;

    i {
      border: solid black;
      border-width: 0 0.125em 0.125em 0;
      display: inline-block;
      padding: 0.1875em;
    }

    .down {
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
    }
  }`;
